import { MutationTree } from 'vuex'
import { TechpacksDictionary, TechpacksState } from './techpacks.model'

export enum MutationTypes {
  GET_TECHPACKS_REQUEST = 'GET_TECHPACKS_REQUEST',
  GET_TECHPACKS_SUCCESS = 'GET_TECHPACKS_SUCCESS',
  GET_TECHPACKS_FAILURE = 'GET_TECHPACKS_FAILURE'
}

export const mutations: MutationTree<TechpacksState> = {
  [MutationTypes.GET_TECHPACKS_REQUEST](state) {
    state.loading = true
  },
  [MutationTypes.GET_TECHPACKS_SUCCESS](state, techpacks: TechpacksDictionary) {
    state.loading = false
    state.errorMessage = undefined
    state.techpacks = techpacks
  },
  [MutationTypes.GET_TECHPACKS_FAILURE](state, errorMessage) {
    state.errorMessage = errorMessage
    state.loading = false
  }
}
